import React from 'react'
import VacationPackageList from '../components/VacationPackagesList'

export default function VacationPackages({...props}) {
	console.log('VacationPackages')
	return (
		<section className="vacation-packages">
			<VacationPackageList />
		</section>
	)
}

